import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import StoryblokClient from 'storyblok-js-client'
import SbEditable from 'storyblok-react'

const Storyblok = new StoryblokClient({
    accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
    cache: {
      clear: 'auto',
      type: 'memory'
    }
})
export default function PrivacyContainer(props) {

  return (
    <>
<SbEditable content={props.privacy[0]}>
      <section className="center_container lg:pt-24 "
        style={{
          background: "#FFF",
        }}
      >
        {/* {
          console.log("privacy", Storyblok.richTextResolver.render(props.privacy[0].maincontent))
          
        } */}
        <div className="container">
          <div className="row w-full resp-ters" style={{ margin: "auto" }}>
            <div
              className="about__text w-full  px-10 lg:px-20"
              style={{ paddingTop: 25 }}
            >
              <div>
                
                <h1 className="text-center">
                  <span className="font-light ">
                    {
                      // console.log("before render",props)
                    }
                    {
                      props.allcomp && props.allcomp.title ? props.allcomp.title:"Privacy Policy"
                    }
                    </span> 
                </h1>
                {/* <h3>For MusicArt minters.</h3> */}
              </div>
              <div className="wrap-line">
              </div>
              
              <div
              dangerouslySetInnerHTML={{__html: `${Storyblok.richTextResolver.render(props.privacy[0].long_text ? props.privacy[0].long_text:props.privacy[0].maincontent)}`}}
              />
             

            </div>
          </div>
        </div>
      </section>
      </SbEditable>
    </>
  );
}
